import moduleRegistry from "@/configuration/module-registry.js"

export default {

  getRouterLinkByIndex(index) {

    var link = moduleRegistry.tree.map(item => {
      return {
        module: item.children
          .filter(module => module.hasOwnProperty('globalSearch'))
          .filter(module => module.hasOwnProperty('routerLink'))
          .filter(module => module.globalSearch.index === index)
      }
    })
      .filter(item => item.module.length > 0)
      .map(item => item.module)
      .flat()?.[0]?.routerLink

    return link;
  },
  getSearchableRouterLinks() {

    return moduleRegistry.tree.map(item => {
      return {
        module: item.children
          .filter(module => module.hasOwnProperty('globalSearch'))
          .filter(module => module.hasOwnProperty('routerLink'))
      }
    })
      .filter(item => item.module.length > 0)
      .map(item => item.module)
      .flat()
      .map(item => item.routerLink)
  },

  findModuleRegistryItemByModuleId(moduleId) {
    var result = moduleRegistry.tree
      .flatMap(group => group.children)
      .filter(item => item.type === 'module')
      .find(item => item.id === moduleId);
    return result;
  },


}
